'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicFormBuilder = require('@gig/magic-form-builder');

var onCountryChange = function (ibanConfig) { return function (value, formState, setField) {
    var ibanAllowed = magicCommon.objectValueOrDefault(ibanConfig, value);
    setField({
        id: 'iban',
        hidden: !ibanAllowed,
    });
}; };
function iban(ibanConfig) {
    return {
        id: 'iban',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'step2-iban',
        validationDisplay: magicFormBuilder.ValidationDisplay.OnTouchShowMessage,
        properties: {
            placeholder: magicCommon.translate('sign-up-step-two.iban.placeholder'),
        },
        validation: [
            {
                name: 'required',
                fn: magicFormBuilder.required,
                message: magicCommon.translate('sign-up-step-two.iban.required-error'),
            },
            {
                name: 'is-valid-iban',
                fn: magicFormBuilder.isValidIban,
                message: magicCommon.translate('sign-up-step-two.iban.error'),
            },
        ],
        triggers: {
            country: onCountryChange(ibanConfig),
        },
        converter: function (formValue) {
            var iban = formValue.iban.value;
            return {
                userAdditionalFields: {
                    iban: iban
                        ? iban.toUpperCase().replace(/[^A-Z0-9]/g, '')
                        : '',
                },
            };
        },
    };
}

exports.iban = iban;
